export const checkIsAppLoadedInIframe = () => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};
